
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/highlights",
      function () {
        return require("private-next-pages/user/highlights.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/highlights"])
      });
    }
  